<template>
  <div>
    <p class="brand-name">电桩品牌：<span style="color:#409eff">{{ this.$route.query.brandName }}</span></p>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :query="query"
      :toolbar="toolbar"
      :selection="false"
      label-width="100px"
    />
  </div>
</template>

<script>
import { HOST } from '@/utils/host'
export default {
  data() {
    return {
      url: '/alarm/count/modalCountlist?brandName=' + this.$route.query.brandName,
      columns: [{
        label: '电桩型号',
        prop: 'modalName'
      }, {
        label: '故障次数',
        prop: 'errorCount'
      }, {
        label: '故障率',
        prop: 'errorCountLv'
      }, {
        label: '同品牌故障占比',
        prop: 'brandCountLv'
      }, {
        label: '平均恢复时长',
        prop: 'goodTime'
      }],
      query: [{
        label: '电桩型号',
        prop: 'modalName',
        placeholder: '请输入电桩型号'
      },
      {
        label: '统计时间',
        prop: 'statisticsTime',
        placeholder: '',
        type: 'date2'
      }
      ],
      toolbar: [{
        label: '导出',
        icon: 'el-icon-download',
        permission: '',
        type: 'primary',
        before: (index, record) => {
          const url = HOST + '/alarm/count/exportModalCountlist'
          const data = this.$refs.tableref.getQueryData()
          $.fileDownload(url, {
            httpMethod: 'GET',
            data: {
              token: window.localStorage.getItem('token'),
              brandName: this.$route.query.brandName,
              ...data
            },
            failCallback: (html, url) => {
              this.$notify({
                title: '失败',
                message: '导出失败',
                type: 'error'
              })
            }
          })
        }
      }]
    }
  }
}
</script>

<style scoped lang="less">
  .brand-name {
    position: absolute;
    top: 172px;
    left: 320px;
    height: 30px;
    line-height: 30px;
    margin: 10px 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/statistics/pileFaultList.vue